import { useMemo } from "react";
import { Typography, Button, Dialog, DialogTitle, DialogContent, DialogActions, Chip } from "@mui/material";
import WhatsAppIcon from "@mui/icons-material/WhatsApp";
import { parseComponents } from "../../utils/whatsappTemplate";
import WhatsAppTemplatePreview from "./WhatsAppTemplatePreview";

// Same tokens as WhatsAppTemplatesPage.jsx's STATUS_COLORS — kept in sync with the app's
// actual brand success/danger colors (src/components/common/Colors.js) rather than
// arbitrary close-but-different hexes.
const STATUS_COLORS = {
  APPROVED: { bg: "rgba(9,172,49,0.12)", color: "#09AC31" },
  PENDING: { bg: "rgba(250,153,5,0.14)", color: "#B36B00" },
  REJECTED: { bg: "rgba(227,76,20,0.10)", color: "#E34C14" },
  PAUSED: { bg: "#F1F1F1", color: "#666" },
  DISABLED: { bg: "#F1F1F1", color: "#666" },
};

// Read-only — Meta only allows editing a template while it's REJECTED (every other
// status, including APPROVED, errors with "Message templates can only be edited if they
// have been rejected"), so this is what every non-rejected template gets instead of the
// full builder.
function TemplatePreviewDialog({ open, onClose, template }) {
  const parsed = useMemo(() => (template ? parseComponents(template.components) : null), [template]);
  if (!template || !parsed) return null;

  const statusColor = STATUS_COLORS[template.status] || STATUS_COLORS.PENDING;

  return (
    <Dialog open={open} onClose={onClose} maxWidth="xs" fullWidth PaperProps={{ sx: { borderRadius: "20px" } }}>
      <DialogTitle sx={{ fontWeight: 800, fontFamily: "Quicksand", display: "flex", alignItems: "center", gap: 1 }}>
        <WhatsAppIcon sx={{ color: "#25D366" }} /> {template.name}
        <Chip size="small" label={template.status} sx={{ bgcolor: statusColor.bg, color: statusColor.color, fontWeight: 700, fontSize: 11, ml: "auto" }} />
      </DialogTitle>
      <DialogContent sx={{ bgcolor: "#FAFBFC" }}>
        <Typography sx={{ fontSize: 12, color: "#9CA3AF", mb: 2 }}>
          {template.category} · {template.language}
        </Typography>
        <WhatsAppTemplatePreview
          headerType={parsed.headerType}
          headerText={parsed.headerText}
          headerMediaUrl={template.headerMediaUrl}
          bodyText={parsed.bodyText}
          bodyVariableSamples={parsed.bodySamples}
          footerText={parsed.footerText}
          buttons={parsed.buttons}
        />
      </DialogContent>
      <DialogActions sx={{ px: 3, py: 2 }}>
        <Button onClick={onClose} sx={{ textTransform: "none", borderRadius: "10px" }}>
          Close
        </Button>
      </DialogActions>
    </Dialog>
  );
}

export default TemplatePreviewDialog;
